import $ from 'jquery'
import { isSP } from './checkScreen'
import 'magnific-popup'

const initGalleryImage = () => {
  const $gallery = $('.js-gallery-image')

  if ($gallery.length > 0 && !isSP()) {
    $gallery.each(function () {
      $(this).magnificPopup({
        delegate: 'a',
        type: 'image',
        mainClass: 'mfp-fade',
        removalDelay: 300,
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          tCounter: '',
        },
        callbacks: {
          buildControls() {
            // re-appends controls inside the main container
            this.contentContainer.append(this.arrowLeft.add(this.arrowRight))
          },
        }
      })
    })
  }
}

const chkScreen = () => {
  const $gallery = $('.js-gallery-image')
  $(window).on('resize', () => {
    if (isSP()) {
      $.magnificPopup.close()
      $gallery.off('click')
      $gallery.removeData('magnificPopup')
    } else {
      initGalleryImage()
    }
  })
}

const initGalleryModal = () => {
  initGalleryImage()
  chkScreen()
}

export default initGalleryModal
